import type { TFunction } from 'i18next';

import sp_header_footer from '@/i18n/locales/en/sp_header_footer.json' with { type: 'json' };

type LanguageSelectorCode = keyof typeof sp_header_footer.languageSelector.language;

const isLanguageSelectorCode = (language: string): language is LanguageSelectorCode => {
  return language.toLowerCase() in sp_header_footer.languageSelector.language;
};

export const mapLanguageAndName = (languages: string[], t: TFunction<'sp_header_footer'>) => {
  return languages.filter(isLanguageSelectorCode).map((language, index) => {
    return {
      id: `${index}`,
      label: t(`languageSelector.language.${language}`),
      value: language,
    };
  });
};
